import { assertNever } from "@p0security/frontend-core";
import { RequestorRule } from "@p0security/shared/types/policy/types";
import { Flex, Typography } from "@p0security/ui";
import { type ReactNode } from "react";
import { colors } from "styles/variables";

export const SectionLabel: React.FC<{ children: ReactNode }> = ({
  children,
}) => (
  <Typography.Text
    className={`block text-sm font-semibold text-[${colors.neutral[60]}]`}
  >
    {children}
  </Typography.Text>
);

export const DetailBlock: React.FC<React.ComponentProps<typeof Flex>> = (
  props
) => <Flex {...props} className={`pl-6 ${props.className ?? ""}`} />;

export const HeaderRow: React.FC<{ children: ReactNode }> = ({ children }) => (
  <Flex align="center" gap={8} className="min-w-0">
    {children}
  </Flex>
);

export const TitleText: React.FC<{
  isPlaceholder?: boolean;
  children: ReactNode;
}> = ({ isPlaceholder, children }) => (
  <Typography.Text
    className={`text-base font-semibold overflow-hidden text-ellipsis whitespace-nowrap min-w-0 ${
      isPlaceholder
        ? `text-[${colors.neutral[40]}] italic`
        : `text-[${colors.neutral[80]}]`
    }`}
  >
    {children}
  </Typography.Text>
);

export const LabeledDetail: React.FC<{
  label: string;
  children: ReactNode;
}> = ({ label, children }) => (
  <Typography.Text>
    <Typography.Text strong>{label}:</Typography.Text> {children}
  </Typography.Text>
);

export const RequestorDetails: React.FC<{ requestor: RequestorRule }> = ({
  requestor,
}) => {
  switch (requestor.type) {
    case "any":
    case "group":
      return null;
    case "user":
      return requestor.uid ? (
        <DetailBlock>
          <LabeledDetail label="Email">{requestor.uid}</LabeledDetail>
        </DetailBlock>
      ) : null;
    case "agentic":
      return null;
    default:
      return assertNever(requestor);
  }
};
